angular.module('core')
    /* ngInject */
    .controller('AuditHistoryLogsDialogController', function ($scope, $http, $uibModalInstance, data) {
        this.$onInit = () => {
            this.data = data;

            let resourceType = data.resourceType;
            let resourceId = data.resourceId;
            $http.get('/crm/api/' + resourceType.toLowerCase() + '/' + resourceId + "/audit").then(success => this.items = success.data);
        }

        this.close = () => $uibModalInstance.close('Canceled');
    });
